<template>
  <!-- 우아한책임 > 안전보건경영 -->
  <section
    :id="hashTitle($t('sustainable.declaration.title'))"
    v-bind="$attrs"
    class="article-anchor esg-sustainable"
  >
    <div class="esg-title-wrap">
      <h4 class="esg-title">{{ $t('menuSustainability.sustainable') }}</h4>
    </div>

    <!-- 안전보건선언문 -->
    <article class="esg-box declaration">
      <div class="esg-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="../../../static/image/company/pc/image_sustainable_declaration@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="../../../static/image/company/m/image_sustainable_declaration@3x.jpg 3x">
            <img src="../../../static/image/company/pc/image_sustainable_declaration.jpg" :alt="$t('compliance.declaration.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('sustainable.declaration.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('sustainable.declaration.paragraph')" class="paragraph" />
        <p class="sign">
          <html-view tag="span" :value="$t('sustainable.declaration.sign')" />
          <!--          <span>-->
          <!--            <img-->
          <!--              src="~@/static/image/sign/leekukhwan.png"-->
          <!--              srcset="~@/static/image/sign/leekukhwan@2x.png 2x, ~@/static/image/sign/leekukhwan@3x.png 3x"-->
          <!--              :alt="$t('sustainable.declaration.sign')"-->
          <!--            >-->
          <!--          </span>-->
        </p>
      </div>
    </article>

    <!-- 안전보건방침 -->
    <article
      :id="hashTitle($t('sustainable.policy.name'))"
      class="article-anchor esg-box policy"
    >
      <div class="esg-box-image">
        <picture>
          <source media="(min-width: 750px)" srcset="../../../static/image/company/pc/image_sustainable_policy@3x.jpg 3x">
          <source media="(max-width: 750px)" srcset="../../../static/image/company/m/image_sustainable_policy@3x.jpg 3x">
          <img src="../../../static/image/company/pc/image_sustainable_policy.jpg" :alt="$t('sustainable.policy.title')">
        </picture>
      </div>
      <div class="esg-box-title">{{ $t('sustainable.policy.title') }}</div>
      <div class="esg-box-content">
        <p class="paragraph">{{ $t('sustainable.policy.paragraph') }}</p>
        <ol class="list-number">
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.policy.list.item1.title') }}</strong>
            </p>
            <p class="list-number-content">{{ $t('sustainable.policy.list.item1.content') }}</p>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.policy.list.item2.title') }}</strong>
            </p>
            <p class="list-number-content">{{ $t('sustainable.policy.list.item2.content') }}</p>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.policy.list.item3.title') }}</strong>
            </p>
            <p class="list-number-content">{{ $t('sustainable.policy.list.item3.content') }}</p>
            <div class="system-head">{{ $t('sustainable.policy.list.item3.system.title') }}</div>
            <div class="system">
              <div class="system-item plan">
                <div class="system-title">{{ $t('sustainable.policy.list.item3.system.plan.title') }}</div>
                <html-view class="system-content" :value="$t('sustainable.policy.list.item3.system.plan.content')" />
                <i />
              </div>
              <div class="system-item do">
                <div class="system-title">{{ $t('sustainable.policy.list.item3.system.do.title') }}</div>
                <html-view class="system-content" :value="$t('sustainable.policy.list.item3.system.do.content')" />
                <i />
              </div>
              <div class="system-item check">
                <div class="system-title">{{ $t('sustainable.policy.list.item3.system.check.title') }}</div>
                <html-view class="system-content" :value="$t('sustainable.policy.list.item3.system.check.content')" />
                <i />
              </div>
              <div class="system-item action">
                <div class="system-title">{{ $t('sustainable.policy.list.item3.system.action.title') }}</div>
                <html-view class="system-content" :value="$t('sustainable.policy.list.item3.system.action.content')" />
              </div>
              <i class="system-line-1" />
              <i class="system-line-2" />
              <i class="system-line-3" />
              <i class="system-line-4" />
            </div>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.policy.list.item4.title') }}</strong>
            </p>
            <p class="list-number-content">{{ $t('sustainable.policy.list.item4.content') }}</p>
          </li>
        </ol>
      </div>
    </article>

    <!-- 안전보건목표 -->
    <article
      :id="hashTitle($t('sustainable.goal.title'))"
      class="article-anchor esg-box goal"
    >
      <div class="esg-box-title">{{ $t('sustainable.goal.title') }}</div>
      <div class="esg-box-content">
        <ol class="list-number">
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.goal.list.item1') }}</strong>
            </p>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.goal.list.item2') }}</strong>
            </p>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.goal.list.item3') }}</strong>
            </p>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('sustainable.goal.list.item4') }}</strong>
            </p>
          </li>
        </ol>
      </div>
    </article>
  </section>
</template>
<script>
import { hashTitle } from '@/util'
export default {
  methods: {
    hashTitle
  }
}
</script>
